import { render, staticRenderFns } from "./historys.vue?vue&type=template&id=b09d03e8&scoped=true&"
import script from "./historys.vue?vue&type=script&lang=js&"
export * from "./historys.vue?vue&type=script&lang=js&"
import style0 from "./historys.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./historys.vue?vue&type=style&index=1&id=b09d03e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09d03e8",
  null
  
)

export default component.exports